import { fdApi } from '../../api';

export const setEmailAddress = (email: string): Promise<void> =>
  fdApi.use(fdApi.user.postSetEmailAddress(email));
